import React, { Component } from 'react';
import { translate } from 'react-i18next';

import { Form } from 'common/components';

class DepreciationFormGeneral extends Component {
  state = { maximumPercentActive: false, maximumAmountActive: false };

  maximumPercentActiveToggle = () => {
    this.setState(
      (state) => ({
        maximumPercentActive: !state.maximumPercentActive,
        maximumAmountActive: false,
      }),
      () => {
        this.props.handleValueChange({ target: { name: 'maximumAmount', value: 0 } });
        this.props.handleValueChange({ target: { name: 'maximumPercent', value: 0 } });
      }
    );
  };

  maximumAmountActiveToggle = () => {
    this.setState(
      (state) => ({
        maximumAmountActive: !state.maximumAmountActive,
        maximumPercentActive: false,
      }),
      () => {
        this.props.handleValueChange({ target: { name: 'maximumAmount', value: 0 } });
        this.props.handleValueChange({ target: { name: 'maximumPercent', value: 0 } });
      }
    );
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.values.maximumAmount) {
      this.setState((state) => ({
        maximumAmountActive: true,
        maximumPercentActive: false,
      }));
    } else if (nextProps.values.maximumPercent) {
      this.setState((state) => ({
        maximumAmountActive: false,
        maximumPercentActive: true,
      }));
    }
  }

  render() {
    const { depreciations, errors, handleValueChange, isSubmitted, t, values } = this.props;

    return (
      <Form.Section title={t('depreciations.form.general')}>
        <div className="row align-items-center">
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Form.FieldInput
              error={(isSubmitted && errors.key) || {}}
              name={'key'}
              label={t('depreciations.fields.key')}
              handleChange={handleValueChange}
              t={t}
              value={values.key}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Form.FieldInput
              error={(isSubmitted && errors.name) || {}}
              name={'name'}
              label={t('depreciations.fields.name')}
              handleChange={handleValueChange}
              t={t}
              value={values.name}
            />
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3 mb-3">
            <Form.FieldSelect
              error={(isSubmitted && errors.criteria) || {}}
              name={'criteria'}
              label={t('depreciations.fields.criteria')}
              handleChange={handleValueChange}
              t={t}
              value={values.criteria}
            >
              <option value="DATE">{t('catalog.depreciationCriteria.elements.date')}</option>
              <option value="MONTH">{t('catalog.depreciationCriteria.elements.month')}</option>
            </Form.FieldSelect>
          </div>
          <div className="col-sm-6 col-md-4 col-lg-3">
            <Form.Checkbox
              name="active"
              className="icheckbox_flat-blue"
              onChange={handleValueChange}
              checked={values.active}
              label={t('common.active', { context: 'female' })}
            />
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-4 offset-sm-4">
            <div className="row">
              <div className="col" style={{ paddingTop: '25px' }}>
                <Form.Checkbox
                  name="maximumAmountActive"
                  className="icheckbox_flat-blue"
                  onChange={this.maximumAmountActiveToggle}
                  checked={this.state.maximumAmountActive}
                />
              </div>
              <div className="col-10">
                <Form.FieldInput
                  type="tel"
                  disabled={!this.state.maximumAmountActive}
                  error={(isSubmitted && errors.maximumAmount) || {}}
                  name={'maximumAmount'}
                  label={t('depreciations.fields.maximumAmount')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.maximumAmount || 0}
                />
              </div>
            </div>
          </div>
          <div className="col-4 offset-sm-4">
            <div className="row">
              <div className="col" style={{ paddingTop: '25px' }}>
                <Form.Checkbox
                  name="maximumPercentActive"
                  className="icheckbox_flat-blue"
                  onChange={this.maximumPercentActiveToggle}
                  checked={this.state.maximumPercentActive}
                />
              </div>
              <div className="col-10">
                <Form.FieldInput
                  type="tel"
                  error={(isSubmitted && errors.maximumPercent) || {}}
                  disabled={!this.state.maximumPercentActive}
                  name={'maximumPercent'}
                  label={t('depreciations.fields.maximumPercent')}
                  handleChange={handleValueChange}
                  t={t}
                  value={values.maximumPercent || 0}
                />
              </div>
            </div>
          </div>
        </div>
      </Form.Section>
    );
  }
}

export default translate()(DepreciationFormGeneral);



// WEBPACK FOOTER //
// src/modules/secured/modules/depreciations/components/form/sections/DepreciationFormGeneral.js